import { utils } from '@hh/global.js'
const { debounce } = utils


function onYoutubeIframeAPIReady(callback) {
  if (window.YT?.Player) {
    callback()
    return
  }
  const previous = window.onYouTubeIframeAPIReady
  window.onYouTubeIframeAPIReady = function () {
    if (typeof previous === 'function') previous()
    callback()
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define(
    'deferred-media',
    class DeferredMedia extends HTMLElement {
      constructor() {
        super()
        this.loadContent = this.loadContent.bind(this)
        this.youtubePlayers = new WeakMap()
        this.isPlaying = false
        this.isSoundOn = false
        this.posterDesktop = this.dataset?.posterDesktop
        this.posterMobile = this.dataset?.posterMobile
        this.querySelector('[data-trigger]')?.addEventListener('click', () => {
          this.togglePlayer()
        })
        if (this.dataset?.id) {
          this.playButton = document.querySelector(
            `[data-play-button="${this.dataset.id}"]`
          )
          this.playButton?.addEventListener('click', () => {
            this.togglePlayer()
          })
          this.playSoundButton = document.querySelector(
            `[data-toggle-sound-button="${this.dataset.id}"]`
          )
          this.playSoundButton?.addEventListener('click', () => {
            this.toggleSound()
          })
        }
      }

      connectedCallback() {
        this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
          'click',
          this.loadContent.bind(this)
        )
        this.setPosters()
        window.addEventListener('resize', debounce(this.setPosters.bind(this)))
      }

      disconnectedCallback() {
        this.querySelector('[id^="Deferred-Poster-"]')?.removeEventListener(
          'click',
          this.loadContent
        )
        window.removeEventListener('resize', this.setPosters)
      }
      setPosters() {
        const mobile = window.matchMedia('(max-width: 1070px)').matches

        this.style.backgroundImage = `url(${
          mobile && this.posterMobile ? this.posterMobile : this.posterDesktop
        })`;
      }

      ensureYoutubePlayer(iframe, options = {}) {
        const { playOnReady = false } = options
        let player = this.youtubePlayers.get(iframe)
        if (player) {
          if (playOnReady) player.playVideo()
          return player
        }
        if (!window.YT?.Player) return null
        const config = playOnReady
          ? {
              events: {
                onReady: (e) => e.target.playVideo(),
              },
            }
          : {}
        player = new YT.Player(iframe, config)
        this.youtubePlayers.set(iframe, player)
        return player
      }

      playVideo(video, type) {
        if (type == 'youtube') {
          const start = () => {
            this.ensureYoutubePlayer(video, { playOnReady: true })
          }
          if (window.YT?.Player) {
            start()
          } else {
            onYoutubeIframeAPIReady(start)
          }
        } else {
          if (window.Vimeo) {
            const player = new Vimeo(video);
            if (this.getAttribute('playing')){
              player.pause();
            }else{
              player.play();
            }
          }
        }

      }

      togglePlayer(forcePause = false, focus = true) {
        const overlay = this.querySelector('.thumbnail__deferred-media-overlay');

        if (overlay) {
          /* Hides videos play/pause button when starting video */
          overlay.style.display = 'none';
        }
        if (this.isPlaying || forcePause) {
          this.querySelectorAll('.js-youtube').forEach((iframe) => {
            const player =
              this.youtubePlayers.get(iframe) || this.ensureYoutubePlayer(iframe)
            if (player?.pauseVideo) {
              player.pauseVideo()
            } else {
              iframe.contentWindow?.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                '*'
              )
            }
          })
          this.querySelectorAll('.js-vimeo').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*')
          })
          this.querySelectorAll('video').forEach((video) => video.pause())
        } else {
          if (!this.getAttribute('loaded')) {
            this.loadContent(focus)
            return
          }

          this.querySelectorAll('.js-youtube').forEach((iframe) => {
            const player =
              this.youtubePlayers.get(iframe) || this.ensureYoutubePlayer(iframe)
            if (player?.playVideo) {
              player.playVideo()
            } else {
              iframe.contentWindow?.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                '*'
              )
            }
          })
          this.querySelectorAll('.js-vimeo').forEach((video) => {
            video.contentWindow.postMessage('{"method":"play"}', '*')
          })
          this.querySelectorAll('video').forEach((video) => video.play())
        }

        this.isPlaying = !this.isPlaying
        if (forcePause) {
          this.isPlaying = false
        }
        this.updateStatus()
      }

      toggleSound(turnOn = false) {
        if (!this.isSoundOn || turnOn) {
          this.querySelectorAll('.js-youtube').forEach((iframe) => {
            const player =
              this.youtubePlayers.get(iframe) || this.ensureYoutubePlayer(iframe)
            if (player?.unMute) {
              player.unMute()
            } else {
              iframe.contentWindow?.postMessage(
                '{"event":"command","func":"unMute","args":""}',
                '*'
              )
            }
          })
          this.querySelectorAll('.js-vimeo').forEach((video) => {
            video.contentWindow.postMessage('{"method":"setVolume", "value":0.8}','*')
          })
          this.querySelectorAll('video').forEach((video) => video.muted=false)
        } else {
          this.querySelectorAll('.js-youtube').forEach((iframe) => {
            const player =
              this.youtubePlayers.get(iframe) || this.ensureYoutubePlayer(iframe)
            if (player?.mute) {
              player.mute()
            } else {
              iframe.contentWindow?.postMessage(
                '{"event":"command","func":"mute","args":""}',
                '*'
              )
            }
          })
          this.querySelectorAll('.js-vimeo').forEach((video) => {
            video.contentWindow.postMessage('{"method":"setVolume", "value":0}','*')
          })
          this.querySelectorAll('video').forEach((video) => video.muted=true)
        }

        this.isSoundOn = !this.isSoundOn
        this.updateStatus()
      }

      updateStatus() {
        if (this.isPlaying) {
          this.setAttribute('playing', 'true')
          this.playButton?.setAttribute('playing', 'true')
        } else {
          this.removeAttribute('playing')
          this.playButton?.removeAttribute('playing')
        }
        if (this.isSoundOn) {
          this.setAttribute('playing-sound', 'true')
          this.playSoundButton?.setAttribute('playing-sound', 'true')
        } else {
          this.removeAttribute('playing-sound')
          this.playSoundButton?.removeAttribute('playing-sound')
        }
      }

      loadContent(focus = true) {
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div')
          content.appendChild(
            this.querySelector('template').content.firstElementChild.cloneNode(
              true
            )
          )

          this.setAttribute('loaded', true)

          utils.pauseAllMedia()

          const deferredElement = this.appendChild(
            content.querySelector('video, model-viewer, iframe')
          )
          if (focus) deferredElement.focus()
          if (
            deferredElement.nodeName == 'VIDEO' &&
            deferredElement.getAttribute('autoplay')
          ) {
            // force autoplay for safari
            deferredElement.play()
          }

          if (this.dataset.id) {
            if(this.querySelector('.js-youtube') != null){
              this.playVideo(this.querySelector('.js-youtube'), 'youtube');
              this.isPlaying = true
              this.updateStatus()
            }
            if(this.querySelector('.js-vimeo') != null){
              this.playVideo(this.querySelector('.js-vimeo'), 'vimeo');
              this.isPlaying = true
              this.updateStatus()
            }
          } else {
            this.isPlaying = true
            this.updateStatus()
          }
        }
      }
    }
  )
}
